module.exports = __webpack_public_path__ + "img/sec_3_box4.ddde0f8b.png";